import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, resetUsersList } from "../../reducers/commonReducer";

const schema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  role: yup.string().required(),
  branch: yup.string().required(),
  status: yup.string().required(),
  password: yup.string().min(6, "Password must be at least 6 characters"),
});

function UpdateCustomer(props) {
  const dispatch = useDispatch();
  const { api, phone, firstName, lastName, role, branch, status, id, title, image } =
    props;
  const [show, setShow] = useState(false);
  const [imagePreview, setImagePreview] = useState(image || "");
  const handleClose = () => {
    setImagePreview(image || "");
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const { getFrontEndBranchList } = useSelector((state) => state.commonReducer);
  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        <i className="bi bi-pencil-square"></i>
      </Button>

      <Modal size={"lg"} show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          onSubmit={async (values) => {
            const cleanedValues = { ...values };
            if (!cleanedValues.password) delete cleanedValues.password;
            const apiResp = await dispatch(api(cleanedValues));
            if (apiResp?.payload?.status) {
              await dispatch(resetUsersList());
              await dispatch(getUsers());
              handleClose();
            }
          }}
          initialValues={{
            phone,
            firstName,
            lastName,
            role,
            branch,
            status,
            image: "",
            id,
            password: "",
          }}
        >
          {({ handleSubmit, handleChange, values, setFieldValue, errors }) => (
            <Form className="container" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First Name"
                      name="firstName"
                      value={values.firstName}
                      onChange={handleChange}
                      isInvalid={!!errors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.firstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last Name"
                      name="lastName"
                      value={values.lastName}
                      onChange={handleChange}
                      isInvalid={!!errors.lastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.lastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Phone"
                      name="phone"
                      value={values.phone}
                      onChange={handleChange}
                      isInvalid={!!errors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={4} sm={12}>
                  <Form.Label>User Role</Form.Label>
                  <Form.Control
                    as="select"
                    onChange={async (e) => {
                      setFieldValue("role", e.target.value);
                    }}
                    name="role"
                    className="form-control"
                    value={values.role}
                    isInvalid={!!errors.role}
                  >
                    <option value="">Select User Role</option>
                     <option value={"customer"}>Customer</option>
                  </Form.Control>
                </Col>
                <Col md={4} sm={12}>
                  <Form.Label>Branch</Form.Label>
                  <Form.Control
                    as="select"
                    onChange={async (e) => {
                      setFieldValue("branch", e.target.value);
                    }}
                    name="branch"
                    className="form-control"
                    value={values.branch}
                    isInvalid={!!errors.branch}
                  >
                    <option value="">Select Branch</option>
                    {localStorage.getItem("slug") === "branch_leader" ? (
                      <option value={localStorage.getItem("branch")}>
                        {localStorage.getItem("branchName")}
                      </option>
                    ) : (
                      !!getFrontEndBranchList &&
                      getFrontEndBranchList?.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name}
                        </option>
                      ))
                    )}
                  </Form.Control>
                </Col>
                <Col md={4} sm={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    onChange={async (e) => {
                      setFieldValue("status", /true/.test(e.target.value));
                    }}
                    name="status"
                    className="form-control"
                    value={values.status}
                    isInvalid={!!errors.status}
                  >
                    <option value="">Select Status</option>
                    <option value={true}>Active</option>
                    <option value={false}>InActive</option>
                  </Form.Control>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6} sm={12}>
                  <Form.Group>
                    <Form.Label htmlFor="customer-image">Profile Image</Form.Label>
                    <Form.Control
                      id="customer-image"
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={(event) => {
                        const selectedFile = event.target.files[0];
                        setFieldValue("image", selectedFile);
                        setImagePreview(
                          selectedFile ? URL.createObjectURL(selectedFile) : ""
                        );
                      }}
                      isInvalid={!!errors.image}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.image}
                    </Form.Control.Feedback>
                  </Form.Group>
                  {imagePreview && (
                    <img
                      src={imagePreview}
                      alt="User preview"
                      className="profile-img mt-2"
                    />
                  )}
                </Col>
                <Col md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Leave blank to keep current password"
                      name="password"
                      autoComplete="new-password"
                      value={values.password}
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Submit
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default UpdateCustomer;
